export enum Direction {
  ADD = 'add',
  REMOVE = 'remove'
}
export enum ChangeType {
  ROOM = 'room',
  ADULT = 'adult'
}

export class RoomOption {
  room: number;
  adult: number;
}

export class ChangeContext {
  changeType: ChangeType;
  direction: Direction;
  state: RoomOption[];
}
